export default {
	"indexTitle": {
		"title1": "Register",
		"title2": "Login",
		"title3": "Download Mobile App",
		"title4": "Deposit",
		"title5": "Withdraw",
		"title6": "Sports",
		"title7": "Live Casino",
		"title8": "Slot Machines",
		"title9": "Poker",
		"title10": "Fishing",
		"title11": "Animal Races",
		"title12": "E-sports",
		"title13": "Lottery",
		"title14": "Promotions",
		"title15": "Download Mobile App",

		"title16": "Popular Games",
		"title17": "Start Game",
		"title18": "Latest News",
		"title19": "Please note, when using Alipay, Octopus, tap&go, BOC, etc. for bank deposits, you must select FPS and verify the payee's full English name!",
		"title20": "All Promotions",
		"title21": "Apply for This Promotion",
		"title22": "I Want to Play",
		"title23": "Balance",
		"title24": "My Account",
		"title25": "VIP",
		"title26": "Deposit",
		"title27": "Withdraw",
		"title28": "Affiliate Program",
		"title29": "Task Log",
		"title30": "Promotions Center",
		"title31": "Game Records",
		"title32": "Financial Records",
		"title33": "Announcements Center",
		"title34": "Affiliate Program",
		"title35": "Direct Members",
		"title36": "My Commission",
		"title37": "Rules Explanation",
		"title38": "Team Members",
		"title39": "New Team Members Today",
		"title40": "Direct Members Count",
		"title41": "New Direct Members Today",
		"title42": "Today's Team Turnover",
		"title43": "Today's Direct Turnover",
		"title44": "Affiliate Earnings",
		"title45": "Bonus",
		"title46": "Subordinate Members Count",
		"title47": "Estimated High Bonus Potential",
		"title48": "Personal Information",
		"title49": "Referral Code",
		"title50": "Invitation Link",
		"title51": "Invitation QR Code",
		"title52": "Promotion Tools",
		"title53": "Download",
		"title54": "My Account",
		"title55": "New Password",
		"title56": "Change Withdrawal Password",
		"title57": "Old Password",
		"title58": "Required",
		"title59": "Please enter your login password",
		"title60": "Confirm New Password",
		"title61": "Cancel",
		"title62": "Update",
		"title63": "Please Enter Old Password",
		"title64": "Please Enter New Password",
		"title65": "Passwords Do Not Match",
		"title66": "Update Failed",
		"title67": "Login Password",
		"title68": "New Withdrawal Password",
		"title69": "6~10 characters in English and numbers combination (special characters allowed)",
		"title70": "Confirm Withdrawal Password",
		"title71": "Please Enter Login Password",
		"title72": "Please Enter New Withdrawal Password",
		"title73": "Deposit Options",
		"title74": "Promotions",
		"title75": "No Data Available",
		"title76": "FPS",
		"title77": "Convenience Store Top-up",
		"title78": "No Deposit Limit",
		"title79": "Service Fee",
		"title80": "No Service Fee",
		"title81": "Please Enter Deposit Amount",
		"title82": "Please Enter Payer Name",
		"title83": "Deposit Bonus",
		"title84": "Please Select",
		"title85": "Get Payment Information",
		"title86": "Payment Instructions",
		"title87": "1. Please select the payment channel, enter the amount, and click submit.",
		"title88": "2. After redirecting to the third-party payment page, follow the instructions to complete the deposit within the time limit.",
		"title89": "3. After the payment is completed, wait for the page to show a successful payment message before closing it to avoid missing the transaction.",
		"title90": "4. After the third-party platform confirms, the system will automatically credit your account.",
		"title91": "5. Payment not credited? Unable to pay? Please contact [Online Customer Service] for assistance.",
		"title92": "Deposit Amount",
		"title93": "Please note the following recipient information and make the transfer",
		"title94": "Recipient Account Number",
		"title95": "Recipient Account Name",
		"title96": "Recipient QR Code",
		"title97": "Deposit Address",
		"title98": "Return to Re-enter",
		"title99": "Confirm Deposit",
		"title100": "Copy Successful!",
		"title101": "Start",
		"title102": "End",
		"title103": "You can check data up to 31 days prior to today",
		"title104": "Search",
		"title105": "Total Deposits",
		"title106": "Total Withdrawals",
		"title107": "Total Promotions",
		"title108": "Rebate Records",
		"title109": "Manual Adjustment Records",
		"title110": "Referral Records",
		"title111": "Task Reward Records",
		"title112": "*There may be delays when accessing data. If no game records are found, please try again later. Overview data is aggregated based on GMT+8 time and only shows data for the last 10 days",
		"title113": "Product Type",
		"title114": "Game",
		"title115": "Date",
		"title116": "Total Bets",
		"title117": "Total Valid Bets",
		"title118": "Total Win/Loss",
		"title119": "Settled",
		"title120": "Bet Amount",
		"title121": "Transaction ID",
		"title122": "No Records Found",
		"title123": "Personal Information",
		"title124": "Bank Card Information",
		"title125": "All Wallets",
		"title126": "Change Login/Withdrawal Password",
		"title127": "Referral Code",
		"title128": "Player Account",
		"title129": "Real Name",
		"title130": "Phone Number",
		"title131": "Registration Time",
		"title132": "Total Amount",
		"title133": "Add New Bank Card",
		"title134": "Bank Card Number",
		"title135": "Account Holder Name",
		"title136": "Must Match Your Bank Account Name, Otherwise Withdrawals Cannot Be Processed",
		"title137": "Recipient Bank",
		"title138": "Bank Account Number",
		"title139": "Please Enter Your Bank Account Number",
		"title140": "Bank Branch",
		"title141": "Please Enter Your Bank Branch",
		"title142": "Confirm",
		"title143": "Please Enter Account Holder Name",
		"title144": "Please Enter Recipient Bank",
		"title145": "Please Enter Bank Account Number",
		"title146": "Please Enter Bank Branch",
		"title147": "Countdown Time",
		"title148": "Daily Deposit",
		"title149": "Above HKD",
		"title150": "Activity Points",
		"title151": "Points",
		"title152": "Cumulative Logins",
		"title153": "Days",
		"title154": "Completed",
		"title155": "Available to Claim",
		"title156": "Task in Preparation",
		"title157": "Platform Announcement",
		"title158": "Total",
		"title159": "Application Time",
		"title160": "Review Time",
		"title161": "Pending Confirmation",
		"title162": "Success",
		"title163": "Failure",
		"title164": "Actual Amount",
		"title165": "Remarks",
		"title166": "Order Number",
		"title167": "More Content",
		"title168": "VIP Level",
		"title169": "Current Level",
		"title170": "VIP Benefits Explanation",
		"title171": "Promotion",
		"title172": "Conditions",
		"title173": "Passed",
		"title174": "Current Points",
		"title175": "Congratulations Achieved",
		"title176": "Exclusive Privileges",
		"title177": "Insufficient Level",
		"title178": "Birthday Bonus",
		"title179": "Claim",
		"title180": "Points History",
		"title181": "Level Up/Down",
		"title182": "Claim Records",
		"title183": "Withdrawal Amount",
		"title184": "Total Audit Deduction",
		"title185": "Withdrawal Password",
		"title186": "Actual Withdrawal",
		"title187": "Withdrawal Amount Should Be Between 1.00 and 10.00",
		"title188": "Please Bind Bank Card First",
		"title189": "Please Enter Withdrawal Amount",
		"title190": "Please Enter Withdrawal Password",
		"title191": "Player Login",
		"title192": "Account",
		"title193": "Password",
		"title194": "Not Registered Yet? Click Here",
		"title195": "Forgot Account",
		"title196": "Forgot Password",
		"title197": "Please Enter Player Account",
		"title198": "Please Enter Player Password",
		"title199": "Player account must have 6-12 characters",
		"title200": "China (China)",
		"title201": "Hong Kong (Hong Kong)",
		"title202": "Re-enter",
		"title203": "Register Now",
		"title204": "Please Enter Account",
		"title205": "Please Enter Password",
		"title206": "Please Enter Phone Number",
		"title207": "Daily Tasks",
		"title208": "Roulette",
		"title209": "Referral Progress",
		"title210": "Contact Us",
		"title211": "About Us",
		"title212": "Logout",
		"title213": "Free Registration",
		"title214": "Sports Events",
		"title215": "Live Entertainment",
		"title216": "Electronic Games",
		"title217": "Card Games",
		"title218": "Fishing Games",
		"title219": "Animal Racing",
		"title220": "E-sports",
		"title221": "Android Scan",
		"title222": "iOS Scan",
		"title223": "Play Now",
		"title224": "Event Period:",


		"title225": "Withdrawal Password",
		"title226": "Payment Channel",
		"title227": "All",
		"title228": "Player Deposit",
		"title229": "Deposit History",
		"title230": "Help Center",
		"title231": "Deposit Help",
		"title232": "Hello,",
		"title233": "Card Management",
		"title234": "Daily Missions",
		"title235": "Cumulative Tasks",
		"title236": "Period Mission",
		"title237": "Check-in Task",
		"title238": "Not Activated",
		"title239": "Change Withdrawal Password",
		"title240": "Player Account",
		"title241": "Roulette wheel points",
		"title242": "Real Name",
		"title243": "mobile number",
		"title244": "Date of Birth",
		"title245": "Registration time",
		"title246": "Last login password",
		"title247": "VIP Record",
		"title248": "Withdrawal History",
		"title249": "Withdrawable amount",
		"title250": "Preferential Audit",
		"title251": "Deductions",
		"title252": "Administrative Costs",
		"title253": "Commission",
		"title254": "Discount",
		"title255": "Normalcy Audit",
		"title256": "Clause",
		"title257": "Heaven",
		"title258": "Amount:",
		"title259": "Get Amount:",
		"title260": "Size:",
		"title261": "Sign-in",
		"title262": "Checked in",
		"title263": "Total Check-in Days:",
		"title264": "Total Sign-in Revenue:",
		"title265": "Deposit amount of the day:",
		"title266": "Valid bets of the day:",
		"title267": "Required Deposit Amount:",
		"title268": "Required number of valid yards:",
		"title269": "Number of turns:",
		"title270": "times",
		"title271": "Completed the mission today",
		"title272": "Not up to standard",
		"title273": "Home",
		"title274": "Offer",
		"title275": "Make money",
		"title276": "Account",
		"title277": "Number of days of no-show",

		"title278": "Check-in Conditions",
		"title279": "Achieved!",
		"title280": "Identity Verification Gold Required",
		"title281": "to participate in this event",
		"title282": "Sign in and get a bonus",
		"title283": "Total number of active days",
		"title284": "Total Prize",
		"title285": "Select Currency",
		"title286": "Please enter your English name",
		"title287": "Account number at least 6",
		"title288": "Bank Account",
		"title289": "Minimum:",
		"title290": "Maximum:",
		"title291": "Top-up amount",
		"title292": "Lowest Deposit Amount",
		"title293": "Highest Deposit amount",
		"title294": "The login status is invalid, please log in again",
		"title295": "Card Name",
		"title296": "Bank",
		"title297": "Card Account Number",
		"title298": "Please enter a 6-digit withdrawal password",
		"title299": "This action will transfer all balances back to the main wallet, do you want to continue?",
		"title300": "Cancel",
		"title301": "Continue",
		"title302": "Withdrawal password is 6 digits",
		"title303": "Funds Recovery",
		"title304": "Customer Service",
		"title305": "Yard Balance",
		"title306": "Real-time Rebate",
		"title307": "Claim",
		"title308": "Minimum deposit amount",

		"title309": "Download for iPhone",
		"title310": "Support Apple",
		"title311": "Above",
		"title312": "Download Android",
		"title313": "Android supported",
		"title314": "WeChat players, please use mobile browser",
		"title315": "Click to copy URL",

		"title316": "Event Prize",
		"title317": "My Prize",
		"title318": "Turntable",
		"title319": "Bonus Bonus:",
		"title320": "The number of valid bets required by a live person:",
		"title321": "The number of valid bets required for fishing:",
		"title322": "The number of electronically qualifying bets is required:",
		"title323": "The number of valid bets on the ticket is required:",
		"title324": "The number of valid bets on sports is required:",
		"title325": "The number of valid bets is required:",
		"title326": "Require the number of other valid bets:",
		"title327": "Baccarat",

		"title328": "Real-time rebate",
		"title329": "Click to claim",
		"title330": "Yuan",
		"title331": "Live Rebate Amount:",
		"title332": "Sports Rebate:",
		"title333": "Electronic Rebate Amount:",
		"title334": "Chess Rebate Amount:",
		"title335": "Claim Instructions",
		"title336": "The claim time is 16:00:00-23:59:59, if not claimed within this time period, it will be cleared",
		"title337": "Only provide 14 days of transaction information inquiry",
		"title338": "Fishing Rebate Amount:",
		"title339": "Esports Rebate:",
		"title340": "Animal Rebate Amount:",
		"title341": "Main wallet",
		"title342": "Game Wallet",
		"title343": "Route selection",
		"title344": "Customer Service (Line 1)",
		"title345": "Customer Service (Line 2)",
		"title346": "Valid Bets",
		"title347": "Not participating in activities",
		"title348":"Sign in activity",
		"title349":"Roulette Lottery",
		"title350":"Let's go for a walk first",
		"title351":"remember password",
		"title352": "Please Enter Your FPS",
		"title353": "Please Enter Your ",
		"title386": "Available to claim",
		"title387": "Claim Reward",
		"title388": "Red Packet Bonus",
		"title389": "Up to",
		"title451": "Upgrade to",
		"title452": "Rules",
		"title453": "Level",
		"title454": "Upgrade Bonus",
		"title455": "Weekly Bonus",
		"title456": "Monthly Bonus",
		"title458": "VIP Level System",
		"title459": "Retention XP",
		"title460": "Upgrade XP",
		"title461": "Promotion Standard",
		"title462": "When a member meets the valid wagering requirement for the corresponding level, the system will automatically promote to the corresponding VIP level. (Valid wagering for each VIP level promotion will be recalculated.)",
		"title463": "Retention Requirement",
		"title464": "After reaching a VIP level, members must complete the retention wagering requirement within 60 days (half of the wagering required for the current level promotion equals the retention wagering). If promoted during this period, retention requirements are recalculated based on the new level.",
		"title465": "Demotion Standard",
		"title466": "If a member fails to meet the retention requirement within 60 days, the system will automatically demote by one level (valid wagering for the demoted VIP level will be recalculated), and corresponding benefits will be adjusted to the demoted level.",
		"title467": "Promotion Bonus",
		"title468": "After promotion, members can claim the promotion bonus on the VIP page. Each level's promotion bonus can only be claimed once. Promotion bonus requires 1x wagering before withdrawal.",
		"title469": "VIP Weekly Red Packet",
		"title470": "VIP red packets can be claimed once per week. The amount depends on the current level. Updated every Monday at 00:00. Expired weekly bonuses cannot be claimed. Red packet requires 1x wagering before withdrawal. Limited to once per week.",
		"title471": "VIP Monthly Red Packet",
		"title472": "VIP red packets can be claimed once per month. The amount depends on the current level. Updated on the 1st of each month at 00:00. Expired monthly bonuses cannot be claimed. Red packet requires 1x wagering before withdrawal. Limited to once per month.",
		"title473": "VIP Club",
		"title477": "Reward already claimed",
		"title478": "Claimed this week",
		"title479": "Claimed this month",
		"title399": "Daily Deposit",
		"title400": "Daily Turnover",
		"title403": "Red Packet Application: Daily deposit amount",
		"title404": "turnover amount",
		"title405": "You can claim on the activity page on the same day.",
		"title406": "Bonus from this activity requires only 1x turnover before withdrawal.",
		"title407": "Each player may apply once per day; maximum random red packet amount",
		"title408": "Each player may register only one account. Multiple accounts for events are considered arbitrage and will be blocked.",
		"title409": "The platform reserves the right to change or terminate this activity and has the final interpretation.",
		"title480": "Claimed Today",
		"title520": "Activity Details",
		"title521": "Claim",
		"title610": "Red Envelope",
		"title437": "Agent Commission",
		"title438": "Referral Code",
		"title440": "Redemption Record",
		"title441": "Valid Bets of Friends Yesterday",
		"title443": "What are the deposit and withdrawal requirements?",
		"title444": "The minimum deposit amount is 100, and the minimum withdrawal amount is 100. For agents withdrawing via USDT, the amount must reach over 10,000; please contact customer service to bind USDT for withdrawal. Commission requires 1 time valid betting turnover before withdrawal.",
		"title445": "How is the referral bonus calculated?",
		"title446": "Referral bonus calculation rule: Invite subordinates to register and place bets, you can get a 0.8% rebate from subordinate members' betting amount. Calculation example: If a subordinate member bets 5,000,000, the commission you can receive is 5,000,000 * 0.8% = 40,000 commission.",
		"title447": "How often are dividend bonuses settled?",
		"title448": "Agent commission is settled in real-time. You will receive commission immediately when your subordinate members place bets.",
		"title474": "Copy",
		"title475": "Invite Friends",
		"title476": "Performance Inquiry",
		"title494": "Commission reward claimed",
		"title532": "Interest Vault",
		"title535": "Total Amount (￥)",
		"title536": "Annual Rate",
		"title537": "Transfer In",
		"title538": "Claim",
		"title539": "Transfer Out",
		"title540": "Current Earnings",
		"title541": "Total Bonus",
		"title542": "Cumulative Earnings",
		"title543": "Details",
		"title544": "Interest Vault Rules",
		"title545": "Earnings",
		"title546": "Claims",
		"title547": "Transfers Out",
		"title548": "Transfers In",
		"title549": "Earnings",
		"title550": "No records yet",
		"title553": "Enter amount",
		"title554": "Confirm",
		"title555": "Interest Rules\n• Main account funds must meet withdrawal turnover requirements before transferring in.\n• Interest is calculated at the annual rate, with each hour as one settlement cycle:\nBalance × annual rate ÷ 365 ÷ 24 = hourly earnings.\n• Earnings start 2 hours after deposit; transfer-out bonus rewards are not affected.\n• Each deposit earns interest for up to 12 hours; after 12 hours, you must deposit again to continue earning.\n• Example at 365% annual rate: 100,000 balance earns about 500 in 12 hours.\n\nTransfer Out Rules\nBonus rate:\n• Each transfer out earns a 1% bonus, up to 2 times per day, max 388 per 1% bonus.\nTransfer requirements:\n• After transfer to the main account, you must complete 1x turnover on (transfer amount + bonus) before withdrawal.",
		"title556": "Operation failed. Please try again later.",
		"title557": "Main Wallet (￥)",
		"title558": "Interest Vault (￥)",
		"title559": "Transfer Amount",
		"title561": "Main account funds must meet turnover and withdrawal conditions before transferring into Interest Vault.",
		"title562": "Transfer Out",
		"title563": "Total Balance",
		"title564": "Unclaimed Earnings",
		"title565": "Transfer Amount",
		"title566": "Bonus Amount",
		"title567": "Bonus Rules:",
		"title568": "1. Transfer-out bonus {rate}%, 2 times/day",
		"title569": "2. After transfer, principal + bonus require 1x turnover",
		"title571": "No balance available to transfer out",
		"title573": "Transfer Bonus",
	},

};